<app-esqueleto-tableros [filterWidth]="500">
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <!-- BORRAR FILTROS -->
  <div borrador>
    <div class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
      (click)="quitarFiltros()" style="transform: scale(0.9);"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <div contenido class="zonaContenido">
    <div class="w3-row">
      <div class="zonaIzq w3-white">
        <div class="headers w3-titulo-contenidomenuSC w3-noventa">
          <span class="w3-margin-left-contenido">{{'financiero.activosPonderados.tituloTabla' |translate}}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">
            @for (per of subTitles; track $index) {
              <span style="margin-left: 5px;">{{escrituraPer(per)}}</span>
            }
          </span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menutabla1">
            more_vert
          </mat-icon>
          <mat-menu #menutabla1="matMenu">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportExcel()">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar'|translate}}</span>
            </button>
          </mat-menu>
        </div>  
        <div class="zonaTabla w3-scroll ">
          @if(dataOrdenado.length > 0){
            <table class="w3-table borderAllLow">
              <thead>
                <tr class="w3-table-title">
                  <th class="stikyColum w3-border-right-balance w3-thite marginsH">{{'financiero.activosPonderados.tit1' |translate}}</th>
                  <th class="stikyColum w3-border-right-balance w3-thite marginsH">{{'financiero.activosPonderados.tit2' |translate}}</th>
                  @for (per of cadenaEvaluacion; track $index) {
                    <th class="w3-elemento-titulo-table  stikyColum w3-border-right-balance marginsH"> <span>{{escrituraPer(per.evaluacion)}}</span> </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (item of dataOrdenado; track item.id; let t = $index) {
                  @for(elem of item; track elem.codigo; let i = $index){
                    @if(elem.codigo === 'suma' || elem.codigo === 'total'){
                      <tr class="w3-table-trtd">
                        <td [ngClass]="{'total':elem.codigo==='suma' || elem.codigo === 'total'}" class="w3-elemento-tableIndicador borderAllLow marginsH" style="min-width: max-content !important; white-space: nowrap;">
                          @if(elem?.cuenta){{{elem.cuenta}}}
                        </td>
                        <td [ngClass]="{'total':elem.codigo==='suma' || elem.codigo === 'total'}" class="w3-elemento-tableIndicador borderAllLow marginsH"
                          style="min-width: max-content !important; white-space: nowrap; cursor: pointer;" (click)="generarGrafica(elem)"
                          matTooltip="{{'financiero.activosPonderados.mostrarEvolucion' |translate}}">
                          @if (mostrarIcon(t,i) && elem.codigo !== 'total') {
                            <div (click)="tablasExpand[t]=!tablasExpand[t];" class="w3-button" style="cursor: pointer;">
                              <mat-icon class="iconoMen">
                                {{tablasExpand[t]?'expand_less':'expand_more'}}
                              </mat-icon>{{elem.descripcion}}
                            </div>                        
                          }@else {
                            {{elem.descripcion}}
                          }
                        </td>
                        @for (serie of elem.series; track serie; let j =  $index) {
                          <td [ngClass]="{'total':elem.codigo==='suma' || elem.codigo === 'total'}" class="w3-elemento-tableIndicador borderAllLow alinRight widthMin marginsH">
                            @if(elem?.porcentaje){
                              {{serie.valor*100 | formaterNumber:2:miles:decimal}}%
                            }@else{
                              {{serie.valor | formaterNumber:0:miles:decimal}}
                            }
                          </td>
                        }
                      </tr>
                    }@else if(elem.codigo !== 'suma' && elem.codigo !== 'titulo' && tablasExpand[t]){
                      <tr class="w3-table-trtd">
                        <td class="w3-elemento-tableIndicador borderAllLow marginsH"
                        style="min-width: max-content !important; white-space: nowrap;">
                          {{elem.codigo}}
                        </td>
                        <td class="w3-elemento-tableIndicador borderAllLow marginsH" (click)="generarGrafica(elem)"
                        matTooltip="{{'financiero.activosPonderados.mostrarEvolucion' |translate}}"
                        style="min-width: max-content !important; white-space: nowrap; cursor: pointer;" >
                          {{elem.descripcion}}
                        </td>
                        @for (serie of elem.series; track serie; let k = $index) {
                          <td class="w3-elemento-tableIndicador borderAllLow alinRight widthMin marginsH"
                          [matTooltip]="elem.edit ? 'Editar' : ''" (dblclick)="elem.edit ? ingresarDato(elem, k) : null">
                            {{serie.valor | formaterNumber:0:miles:decimal}}
                            @if(elem.edit){
                              <mat-icon class="iconoMen">edit</mat-icon>
                            } 
                          </td> 
                        }
                      </tr>
                    }@else if(elem.codigo === 'titulo'){
                      <tr class="w3-table-trtd">
                        <td class="w3-elemento-tableIndicador borderAllLow marginsH" style="font-weight: bold;" [attr.colspan]="elem.series.length + 2">
                          {{elem.descripcion}}
                        </td>  
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          }@else {<app-skeleton-table [columnas]="8" [filas]="15"/>}
        </div>
      </div>
      <div class="zonaDer">
        <div class="zonaSup w3-white">
          @if(dataGraf){
            <div class="headers w3-titulo-contenidomenuSC w3-threequarter textoOverFlow"
              [matTooltip]="('financiero.activosPonderados.evolucion' | translate) +' ' +tituloGraf +' • ' +escrituraPer(subTitles[subTitles.length - 1])">
              <span class="w3-margin-left-contenido">{{'financiero.activosPonderados.evolucion' |translate}} {{tituloGraf}}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles[subTitles.length-1])}}
              </span>
            </div>
            <div class="w3-rest w3-right">
              <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="etiquetas = !etiquetas" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                {{ etiquetas ? 'label_off' : 'label' }}
              </mat-icon>
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                  (click)="openModal = !openModal"
                  matTooltip="{{'financiero.evaluacionIndicador.tooltipIcono2'|translate}}">
                  zoom_out_map
              </mat-icon>
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuGraf">
                more_vert
              </mat-icon>
              <mat-menu #menuGraf="matMenu">
                <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
                    [matMenuTriggerFor]="menuTiposGraf">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
                </button>
                <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportGraf()">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #menuTiposGraf="matMenu">
                <button mat-menu-item [ngClass]="{'w3-disabled': tipo === typeGraph.BARHORIZONTAL}" [disabled]="tipo == typeGraph.BARHORIZONTAL"
                    (click)="tipo = typeGraph.BARHORIZONTAL">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'graf.horizontal'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': tipo === typeGraph.BAR}" [disabled]="tipo == typeGraph.BAR"
                    (click)="tipo = typeGraph.BAR">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'graf.vertical'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': tipo === typeGraph.LINE}" [disabled]="tipo == typeGraph.LINE"
                    (click)="tipo = typeGraph.LINE">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': tipo === typeGraph.AREA}" [disabled]="tipo == typeGraph.AREA"
                    (click)="tipo = typeGraph.AREA">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
                </button>
            </mat-menu>
            </div>
            <div class="w3-row" style="height: 85%;">
              <app-graficador #grafica
                  [etiquetas]="etiquetas"
                  [data]="dataGraf"
                  [labels]="dataEtiquetas"
                  [type]="tipo"
                  [axisX]="tipo === typeGraph.BARHORIZONTAL ? 'Saldo' : 'Periodo'"
                  [axisY]="[tipo !== typeGraph.BARHORIZONTAL ? 'Saldo' : 'Periodo']"
                  [zona]="1"
                  [colors]="colorScheme"
                  [formatEtiquetas]="true"
                  [animations]="true"
                  [speedAnimations]="500"
                  [legend]="{enabled: true, position: 'bottom'}"/>
            </div>  
          }@else {<app-skeleton-grafica/>}          
        </div>
        <div class="zonaInf">
          <div class="tarjeta">
            @if(tarjetas.length > 0){
              <app-tarjetas [header]="tarjetas[0].titulo" [valueStr]="tarjetas[0].valor*100 | formaterNumber:2:miles:decimal"
                [footer]="escrituraPer(subTitles[subTitles.length-1])" [icon]="'percent'" [iconFirst]="false"
              />
            }@else {<app-skeleton-card/>}          
          </div>
          <div class="tarjeta">
            @if(tarjetas.length > 0){
              <app-tarjetas [header]="tarjetas[1].titulo" [valueStr]="tarjetas[1].valor | formaterNumber:0:miles:decimal"
                [footer]="escrituraPer(subTitles[subTitles.length-1])" [icon]="' '" [iconFirst]="false"
              />
            }@else {<app-skeleton-card/>}          
          </div>
        </div>
      </div>    
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="openModal" (close)="openModal = !openModal">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <div class="headers w3-titulo-contenidomenuSC w3-noventa textoOverFlow">
        <span class="w3-margin-left-contenido">{{'financiero.activosPonderados.evolucion' |translate}} {{tituloGraf}}</span>
        <span class="w3-margin-left-contenido">&bull;</span>
        <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles[subTitles.length-1] ?? '')}}
        </span>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <!-- Icono de etiquetas para modal -->
          <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas = !etiquetas" [matTooltip]="etiquetas ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
            {{ etiquetas ? 'label_off' : 'label'}}
          </mat-icon>
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportGraf()" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>  
    </div>
  </div>
  <div modal-body>
    <!--area grafica-->
    <div style="width: 70vw;" >
      <div class="w3-row contentGraf">
        @if (openModal) {
          <app-graficador 
            [data]="dataGraf" 
            [labels]="dataEtiquetas" 
            [type]="tipo"
            [colors]="colorScheme" 
            [axisX]="tipo === typeGraph.BARHORIZONTAL ? 'Saldo' : 'Periodo'"
            [axisY]="[tipo !== typeGraph.BARHORIZONTAL ? 'Saldo' : 'Periodo']"
            [zona]="2" 
            [etiquetas]="etiquetas"
            [legend]="{enabled: true, position: 'bottom'}"
            [animations]="true">
          </app-graficador>
        }
      </div>
    </div>
  </div>
</app-modal>